<template>
<defaultLayout section="page-no-found">
  <template slot-scope="slotProps">
  <four-oh-four :data="data" />
  </template>
</defaultLayout>
</template>

<script>
// Components
import DefaultLayout from '@/layouts/default';
import FourOhFour from '@/modules/FourOhFour';

export default {

  name: 'PageNotFound',

  props: ['data'],

  components: {
    DefaultLayout,
    FourOhFour,
  },

};
</script>



// WEBPACK FOOTER //
// src/components/PageNotFound.vue